import authRoles from '../../../auth/authRoles';
import ProviderStates from './ProviderStates';

const DirectoryConfig = {
  settings: {
    layout: {
      style: 'layoutMarketingV2',
      config: {
        header: {
          display: true
        },
        footer: {
          display: true
        }
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: '/directory/providers',
      element: <ProviderStates />,
    },
  ],
};

export default DirectoryConfig;